import React from 'react';
import withVirtualScroll from '../../../../dispatcher/hoc/withVirtualScroll';
import { PureComponent } from '../../../../dispatcher/modules';
import * as _ from 'lodash';
import uuid from 'uuid-random';
import PuzzleMultiselect from './PuzzleMultiselect';
import {
  PUZZLE_REMOTE_MULTISELECT_PROPS,
  PUZZLE_REMOTE_MULTISELECT_STATE
} from './Types';

/**
 * Remote data and filter combo box
 */
class PuzzleRemoteMultiselect extends PureComponent<PUZZLE_REMOTE_MULTISELECT_PROPS, PUZZLE_REMOTE_MULTISELECT_STATE> {
  moduleId = uuid();

  /**
   * Call external parseData function
   * @param data
   */
  parseData = (data: any) => {
    if (_.isFunction(this.props.parseData)) {
      data = this.props.parseData(data);
    }

    return data;
  };

  /**
   * Set data is function from virtual scroll component
   * preferably it should not be changed
   * @param data
   */
  setData = (data: any) => {
    _.get(this, 'props.setData') && this.props.setData(data);
  };

  render() {
    let popupClass = 'data-preventrecorddeselect';

    if (this.props.virtual.total < 6) {
      popupClass += ' tp-remote-combo-box-popup';
    }

    return (
      <PuzzleMultiselect
        {...this.props}
        popupSettings={{
          popupClass
        }}
      />
    );
  }
}

export default withVirtualScroll(PuzzleRemoteMultiselect);
